/**
 * Store id to keep in the merchant session.
 * A list that has not finished loading must not clear a selection: the header
 * used to write "" on that render, and the next redemption was submitted with
 * no store.
 */
export function chooseMerchantStoreId(stores, storedId, { loaded = false } = {}) {
  const list = Array.isArray(stores)
    ? stores.filter((store) => store && store._id && store.active !== false)
    : [];
  const stored = storedId ? String(storedId) : "";
  if (!loaded) return stored;
  if (stored && list.some((store) => String(store._id) === stored)) return stored;
  if (list.length > 0) return String(list[0]._id);
  return "";
}
